<template>
  <div id="pmlst-main">
    <transition name="pane" mode="in-out">
      <title-bar v-if="isCurrentState('active')"
        ><span v-html="titlebar"></span></title-bar
    ></transition>
    <div class="pmlst-main-wrapper">
      <transition name="pane" mode="out-in">
        <loading-screen v-if="isCurrentState('loading')">{{
          loading
        }}</loading-screen>
        <pure-start-screen
          v-if="isCurrentState('startup')"
          :startup="startup"
        />
        <quiz-screen
          v-if="isCurrentState('active')"
          :showtextpane="showtextpane"
        />
        <outcome-screen v-if="isCurrentState('outcome')"></outcome-screen>
        <error-screen v-if="isCurrentState('error')">{{
          errortext
        }}</error-screen>
      </transition>
    </div>
    <pure-disclaimers v-if="typeof disclaimers === 'string'"
      ><span v-html="disclaimers"></span
    ></pure-disclaimers>
  </div>
</template>

<script>
import SelectionToolData from '@/data/SelectionToolData'
import PureDisclaimers from '@/components/PureDisclaimers'
import TitleBar from '@/components/TitleBar'
import ErrorScreen from '@/views/ErrorScreen'
import LoadingScreen from '@/views/LoadingScreen'
import OutcomeScreen from '@/views/OutcomeScreen'
import PureStartScreen from '@/views/PureStartScreen'
import QuizScreen from '@/views/QuizScreen'

export default {
  name: 'selection-tool',
  components: {
    LoadingScreen,
    ErrorScreen,
    OutcomeScreen,
    PureStartScreen,
    PureDisclaimers,
    QuizScreen,
    TitleBar
  },
  props: {
    loadingtext: {
      type: String,
      required: true
    },
    titlebar: {
      type: String,
      required: true
    },
    errortext: {
      type: String,
      required: true
    },
    showtextpane: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectionToolData: SelectionToolData,
      selectiontool: {
        overridestate: false,
        loading: null,
        titlebar: null,
        outcome: null,
        disclaimers: null,
        error: null,
        state: 'loading'
      }
    }
  },
  computed: {
    currentState() {
      return this.$store.getters.getApplicationState
    },
    loading() {
      return this.$props.loadingtext
    },
    error() {
      return this.selectiontool.error
    },
    startup() {
      return this.selectionToolData.config.startup
    },
    disclaimers() {
      return this.selectionToolData.config.disclaimers
    }
  },
  mounted() {
    this.parseSelectionToolData()
  },
  methods: {
    isCurrentState(stateName) {
      return this.currentState === stateName
    },
    parseSelectionToolData() {
      // Configure the step tracker...
      // * Default current state = 0 (no questions answered yet).
      this.$store.dispatch('setSteptrackerCurrent', 0)
      // * Default max state = number of questions with no prereqs?
      let ungatedQuestions = this.selectionToolData.questions.filter(
        question => typeof question.prereq === 'undefined'
      )
      this.$store.dispatch('setSteptrackerMax', ungatedQuestions.length)
      // Sync the data from selectionToolData.js to the VueX store.
      this.$store.dispatch('syncOutcomes', this.selectionToolData.outcomes)
      this.$store.dispatch('syncQuestions', this.selectionToolData.questions)
      this.$store.dispatch('syncTextpanes', this.selectionToolData.textpanes)
      // Set the default first question to be displayed.
      this.$store.dispatch(
        'switchToQuestion',
        this.selectionToolData.questions[0].id
      )
      // Switch from the LOADING state to the STARTUP state
      this.$store.dispatch('setState', 'startup')
    }
  }
}
</script>
